export const AvReason = {
    CHANGEMENT_DE_GARANTIES: {
        label: 'Changement de garanties',
        value: '2',
    },
    AJOUT_DE_VEHICULES: {
        label: 'Ajout de véhicules',
        value: '1',
    },
};

export const AvReasonArray = Object.values(AvReason);

export type AvReasonType = keyof typeof AvReason;

export const AvReasonKeyValue = Object.entries(AvReason).reduce<any>((acc, [key, { value }]) => {
    acc[key] = value;
    return acc;
}, {}) as Record<AvReasonType, string>;
